/**
 * Synchronise GridStack avec le mode personnalisation :
 * active ou désactive le drag / resize via setStatic() et applique les styles CSS d'édition.
 * En édition, on étend la grille de quelques lignes vides sous le contenu (minRow)
 * pour offrir une zone droppable confortable vers le bas.
 */
import { useEffect } from "react";
import { useGridStackContext } from "../../lib";
import { useDashboardEdit } from "./DashboardEditContext";

/** Lignes vides ajoutées sous le contenu en mode édition (zone de drop). */
const EDIT_EXTRA_ROWS = 8;

export function DashboardGridEditController() {
  const { gridStack } = useGridStackContext();
  const { isEditing } = useDashboardEdit();

  useEffect(() => {
    if (!gridStack) return;

    gridStack.setStatic(!isEditing);

    const container = gridStack.el;
    if (container) {
      container.classList.toggle("dashboard-grid-editing", isEditing);
    }

    // Étend la grille en édition (espace droppable en bas), la rétracte sinon.
    gridStack.updateOptions({
      minRow: isEditing ? gridStack.getRow() + EDIT_EXTRA_ROWS : 0,
    });
  }, [gridStack, isEditing]);

  return null;
}
